import BnumElement from '../../../bnum-element';
import { OnElementChangedEvent } from './types';
import { EVENT_DEFAULT } from '../../../../core/utils/constants/constants';
import { CHANGE_EVENT } from './constants';

export function onElementChangedInitializer(
	event: OnElementChangedEvent,
	instance: BnumElement,
) {
	event.add(EVENT_DEFAULT, data => {
		instance.trigger(CHANGE_EVENT, { detail: data });
	});
}
